import { render } from "./CompanyRowSkeleton.vue?vue&type=template&id=52788a9e"
import script from "./CompanyRowSkeleton.vue?vue&type=script&lang=ts"
export * from "./CompanyRowSkeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script